import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_107: FaireProductEntity = {
  token: "starter_collection_107",
  type: "product",
  name: "G10 Lark Knife",
  brandName: "Craighill",
  imageUrl:
    "https://cdn.faire.com/fastly/0da473594014e0ac975d29af1cef6e385afa8ce7e788555f9f296ad4793a84b3.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 95,
  msrpDollars: 190,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
